
export default function Footer() {
  return (
    <footer className="py-16 lg:py-20 bg-black">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Main Content */}
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 mb-16">
          {/* Brand */}
          <div className="lg:col-span-4">
            <p className="text-lg font-light text-white mb-6">모래요정 K-Star 샌드아트</p>
            <p className="text-sm text-white/50 font-light leading-relaxed">
              모래로 그리는 이야기,<br />
              순간을 기억으로 남기는 샌드아트
            </p>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <p className="text-xs font-medium tracking-widest uppercase text-white/30 mb-6">Contact</p>
            <div className="space-y-3">
              <p className="text-sm text-white/70 font-light">대표 이길식</p>
              <p className="text-sm text-white/70 font-light">010-5529-0122</p>
              <p className="text-sm text-white/70 font-light">kildedee@naver.com</p>
            </div>
          </div>

          {/* Locations */}
          <div className="lg:col-span-4">
            <p className="text-xs font-medium tracking-widest uppercase text-white/30 mb-6">Locations</p>
            <div className="space-y-3">
              <p className="text-sm text-white/70 font-light">부산 051-915-5841</p>
              <p className="text-sm text-white/70 font-light">대구 053-592-3122</p>
              <p className="text-sm text-white/70 font-light">울산 052-260-5841</p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <p className="text-xs text-white/30 font-light">
              © 모래요정 K-Star 샌드아트
            </p>

          </div>
        </div>
      </div>
    </footer>
  );
}
